// @flow
import { ActiveExhibitions, UnmappedActiveExhibitions } from "./types";

export const mapActiveExhibitions: ActiveExhibitions = (datum: UnmappedActiveExhibitions) => {
    if (!datum) return
    return {
        id: datum.MainExhibitionId, // MainExhibitionId has etheir main exhibition from coorganization or simple exhibition id
        coorganizationIds: datum.ids, // Ids of all exhibitions in coorganization
        isCoorganization: datum.isCoorganization === "1",
        coorganizationId: datum.id,
        mainExhibitionId: datum.MainExhibitionId,
        title: datum.Description ?? {
            en: datum.Description ?? '',
            el: datum.Description ?? '',
        },
    }
}